module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/play-solid-6c8befbdb8e2d47cc76f3d2e6d8c8e53.svg&quot;;"